import React, { useState, useEffect } from 'react';
import { shallow } from 'zustand/shallow';
import styled from 'styled-components';
import { Button, Flex, Text, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import ViewTitle from '@components/Microsite/ViewTitle';
import { LoyaltyMembership } from '@components/LoyaltyMembership';
import { HogMembership } from '@components/LoyaltyMembership';

import hogLogo from '@assets/images/hog-logo-color.png';

import useAppStore from '@components/Microsite/microsite-store';

export default function MembershipView() {
  const [showModal, setShowModal] = useState(false);
  const [setJoinOrRenew, setSetJoinOrRenew] = useState(false);
  const { t } = useTranslation();
  const {
    location,
    setActiveStep,
    setMembershipInfo,
    user,
    coords,
    entityInfo,
    setUser,
    searchParamsOnInit,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      location: state.location,
      setActiveStep: state.setActiveStep,
      setMembershipInfo: state.setMembershipInfo,
      user: state.user,
      entityInfo: state.entityInfo,
      setUser: state.setUser,
      searchParamsOnInit: state.searchParamsOnInit,
    }),
    shallow
  );

  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  return (
    <div>
      <StyledLogo src={hogLogo} />
      {isVehicleDataEffort && (
        <Text c="white" align="center" size="lg" mb="xl">
          {t('microsite:vehicle_data_membership_required_text')}
        </Text>
      )}
      <HogMembership
        additionalReqData={{
          ...coords,
          location_id: entityInfo.organization_id ? null : location?.id,
          organization_id: entityInfo.organization_id,
          user_id: user?.id,
          campaign_effort_id: entityInfo.campaign_effort_id,
        }}
        setMembershipInfo={(e) => {
          setMembershipInfo(e);
          setUser({
            ...user,
            hog_membership_data: {
              ...e,
            },
          });
          // setActiveStep("vehicle");
          if (location && !location.present_at_location) {
            setActiveStep('present_at_location');
          } else {
            setActiveStep('vehicle');
          }
        }}
        searchParamsHogIdValue={searchParamsOnInit?.hog_id}
        userInfo={user}
      />
    </div>
  );

  return (
    <div>
      <StyledLogo src={hogLogo} />
      {/* <ViewTitle
        title=""
        subtitle={`Harley Owners Group and Passenger (formerly Associate members), add your Member ID here`}
      /> */}
      {isVehicleDataEffort && (
        <Text c="white" align="center" size="lg" mb="xl">
          A Member ID is required to receive mileage credit. Ask a dealer if you
          need help locating your ID number.
        </Text>
      )}
      {user && (
        <LoyaltyMembership
          additionalReqData={{
            check: true,
            user_id: user.id,
            user_location_id: user.user_location_id,
            variety: 1,
            campaign_effort_id: entityInfo.campaign_effort_id,
            dashboard: false,
          }}
          codeVerificationData={{
            ...coords,
            user_location_id: user?.user_location_id,
            campaign_effort_id: entityInfo.campaign_effort_id,
            location_id: location?.id,
            user_id: user?.id,
          }}
          setMembershipInfo={(e) => {
            setMembershipInfo(e);
            setActiveStep('vehicle');
          }}
          rejectUnverified
          defaultShowSignup={setJoinOrRenew}
        >
          {/* {!entityInfo.require_membership && ( */}
          {!isVehicleDataEffort && (
            <Button
              onClick={() => setActiveStep('vehicle')}
              size="xs"
              c="dark"
              color="gray.1"
              radius="lg"
            >
              I'll do this later
            </Button>
          )}
        </LoyaltyMembership>
      )}
      <Modal
        styles={{
          header: {
            backgroundColor: 'var(--mantine-color-dark-9)',
          },
          content: {
            backgroundColor: 'var(--mantine-color-dark-9)',
          },
          body: {
            backgroundColor: 'var(--mantine-color-dark-9)',
            borderRadius: '2px',
          },
        }}
        opened={showModal}
        onClose={() => setShowModal(false)}
        withCloseButton={false}
      >
        <StyledLogo size={`${250}px`} src={hogLogo} />
        <Text c="gray.1" size="lg" fw={600} align="center">
          Make Every Mile Count.
        </Text>
        <Text c="gray.1" size="lg" align="center" mb="md">
          Complete your first odometer reading today to start earning rewards.
          (You'll need at least two during the challenge.)
        </Text>
        <Text c="gray.1" size="lg" align="center" mb="xl">
          H.O.G. and Passenger members earn the most - add your ID or join now
          to maximize your rewards.
        </Text>
        <Button size="md" onClick={() => setShowModal(false)} fullWidth>
          Add my Member ID
        </Button>
        <Flex justify="center" mt="xl" gap="xs">
          <Button
            onClick={() => {
              setShowModal(false);
              setSetJoinOrRenew(true);
            }}
            size="xs"
            c="dark"
            color="gray.1"
            radius="lg"
          >
            Join or Renew
          </Button>
          <Button
            onClick={() => setActiveStep('vehicle')}
            size="xs"
            c="dark"
            color="gray.1"
            radius="lg"
          >
            I'll do this later
          </Button>
        </Flex>
        <Flex justify="center" mt="xl">
          <Button
            size="sm"
            color="gray"
            variant="subtle"
            onClick={() => setActiveStep('vehicle')}
          >
            Add my first VIN
          </Button>
        </Flex>
      </Modal>
    </div>
  );
}

const StyledLogo = styled.img`
  max-width: ${(props) => props.size || '300px'};
  margin: 0 auto 1em auto;
  display: block;
`;
